module.exports = __webpack_public_path__ + "static/media/post_procedure_check_in_big.d199489a.png";